import styled from 'styled-components'
import { DefaultFontStyle } from '../../../styles/global-styles'

export const OptionsDropDown = styled.div`
  background: ${props => props.theme.colours.white};
  border-radius: 8px;
`

export const OptionsDropDownContent = styled.ul`
  position: absolute;
  right: 10%;
  list-style-type: none;
  box-shadow: 0px 4px 4px 2px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  background-color: white;
  margin: 0;
  padding: 0;
  width: 141px;
  border-radius: 8px;
  overflow: hidden;
  @media only screen and (max-width: ${props => props.theme.breakpoints.md}px) {
    right: 12%;
  }
  @media only screen and (min-width: ${props => props.theme.breakpoints.xl}px) {
    right: 6.5%;
  }
  @media only screen and (min-width: ${props => props.theme.breakpoints.xxl}px) {
    right: 5.5%;
  }
`

export const DropDownItem = styled.li`
  background-color: white;
  height: 21px;
  &:hover {
    opacity: 1;
    background-color: #d9d9d9;
  }
`

export const DropDownItemButton = styled.button`
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  color: black;
  width: 100%;
  height: 100%;
  text-align: left;
  background: none;
  color: ${({ disabled }) => (disabled ? '#afafaf' : 'inherit')};
  border: none;
  margin-left: 12px;

  ${DefaultFontStyle};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`
export const MoreOptionsButton = styled.div`
  opacity: 30%;
  width: 100%;
  &:hover,
  &:focus {
    cursor: pointer;
    opacity: 50%;
  }
`
